import React from 'react'
import { ErrorBoundary } from 'react-error-boundary'

import TrialContainer from '../features/trial/components/Trial.container'
import FallbackErrorMessage from '../utils/errors/FallbackMessage'

export const TrialPage: React.FC = () => {
  return (
    <ErrorBoundary FallbackComponent={FallbackErrorMessage}>
      <TrialContainer />
    </ErrorBoundary>
  )
}
